import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const data = [{
  name: 'Ene',
  value: 4000
}, {
  name: 'Feb',
  value: 3000
}, {
  name: 'Mar',
  value: 2000
}, {
  name: 'Abr',
  value: 2780
}, {
  name: 'May',
  value: 1890
}, {
  name: 'Jun',
  value: 2390
}];
export const BarChart = () => {
  return <div className="h-[400px] w-full" data-id="element-294">
      <ResponsiveContainer width="100%" height="100%" data-id="element-295">
        <RechartsBarChart data={data} margin={{
        top: 20,
        right: 30,
        left: 20,
        bottom: 5
      }} data-id="element-296">
          <CartesianGrid strokeDasharray="3 3" data-id="element-297" />
          <XAxis dataKey="name" data-id="element-298" />
          <YAxis data-id="element-299" />
          <Tooltip data-id="element-300" />
          <Bar dataKey="value" fill="#3B82F6" radius={[4, 4, 0, 0]} data-id="element-301" />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>;
};